<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      let _this = this;
      this.chart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          backgroundColor:'rgba(255,255,255,1)'
        },
        // legend: {
        //   orient: "vertical",
        //   left: "60%",
        //   y: "center",
        //   textStyle: {
        //     color: _this.isbig ? "#AABEFF" : "",
        //   },
        // },
        series: [
          // {
          //     name: 'Access From',
          //     type: 'pie',
          //     selectedMode: 'single',
          //     radius: [0, '30%'],
          //     center: ['50%', '60%'],
          //     label: {
          //         position: 'inner',
          //         fontSize: 14
          //     },
          //     labelLine: {
          //         show: false
          //     },
          //     data: [
          //         { value: 1548, name: '帮扶' },
          //         { value: 775, name: '帮教' },
          //         { value: 679, name: '救助', selected: true }
          //     ]
          // },
          {
            type: "pie",
            radius: ["20%", "60%"],
            center: ["50%", "50%"],
            // roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            // labelLine: {
            //   length: 30,
            // },
            // label: {
            //   // show:false,
            //   formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
            //   backgroundColor: "#F6F8FC",
            //   borderColor: "#8C8D8E",
            //   borderWidth: 1,
            //   borderRadius: 4,
            //   rich: {
            //     a: {
            //       color: "#6E7079",
            //       lineHeight: 22,
            //       align: "center",
            //     },
            //     hr: {
            //       borderColor: "#8C8D8E",
            //       width: "100%",
            //       borderWidth: 1,
            //       height: 0,
            //     },
            //     b: {
            //       color: "#4C5058",
            //       fontSize: 14,
            //       fontWeight: "bold",
            //       lineHeight: 33,
            //     },
            //     per: {
            //       color: "#fff",
            //       backgroundColor: "#4C5058",
            //       padding: [3, 4],
            //       borderRadius: 4,
            //     },
            //   },
            // },
            data: [
              { value: 578, name: "晋安区人民检察院" },
              { value: 578, name: "晋安区政法委员会" },
              { value: 578, name: "晋安区公安分局" },
              { value: 578, name: "晋安区民政局" },
              { value: 578, name: "晋安区教育局" },
              { value: 578, name: "晋安区人力资源和社会保障局" },
              { value: 578, name: "晋安区妇女联合会" },
              { value: 578, name: "中国共青团福州市晋安区委" },
              { value: 578, name: "福州市晋安区工商业联合会" },
              { value: 578, name: "晋安区司法局" },
              { value: 578, name: "晋安区人民法院" },
              { value: 578, name: "北极星王庄街道社工站" },
              { value: 578, name: "北极星岳峰镇社工站" },
              { value: 578, name: "北极星两岸社区交流中心社工站" },
            ],
            label:{
                textBorderColor:'transparent',
                textBorderWidth:0,
                color: _this.isbig ? "#AABEFF" : "",
            },
          },
        ],
      });
    },
  },
};
</script>
